'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var rollbar = exports.rollbar = function rollbar() {
  return __CLIENT__ ? window.Rollbar : global.rollbar;
};

var rollbarMethod = function rollbarMethod(method) {
  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  if (__LOCAL_DEV__) {
    var _console;

    (_console = console)[method].apply(_console, args); // eslint-disable-line no-console
  }
  var rb = rollbar();
  if (rb) {
    rb[method].apply(rb, args);
  }
};

var log = exports.log = rollbarMethod.bind(null, 'log');
var error = exports.error = rollbarMethod.bind(null, 'error');
var warn = exports.warn = rollbarMethod.bind(null, 'warn');
var info = exports.info = rollbarMethod.bind(null, 'info');
var debug = exports.debug = rollbarMethod.bind(null, 'debug');